import { useCallback, useSyncExternalStore } from "react";

import type { ParticipantSnapshot } from "./table-call-participant-directory.js";
import { useTableCall } from "./use-table-call.js";

export type { RemoteCallState } from "./table-call-participant-directory.js";

const EMPTY_SUBSCRIPTION = () => null;
const EMPTY_PARTICIPANT_SNAPSHOT: ParticipantSnapshot = {
  remote: null,
  sequence: 0,
};

export const useTableCallParticipant = (userId: string) => {
  const { participantDirectory } = useTableCall();
  const subscribe = useCallback(
    (onStoreChange: () => void) =>
      participantDirectory
        ? participantDirectory.subscribe(userId, onStoreChange)
        : EMPTY_SUBSCRIPTION,
    [participantDirectory, userId]
  );
  const getSnapshot = useCallback(
    () =>
      participantDirectory?.getSnapshot(userId) ?? EMPTY_PARTICIPANT_SNAPSHOT,
    [participantDirectory, userId]
  );
  const snapshot = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

  return { remote: snapshot.remote };
};
